<template>
  <div class="help-module" data-cy="help-module">
    <div class="help-module__title">Help and How to</div>
    <TileModule :items="items">
      <template v-slot="props">
        <a
          :href="props.item.url"
          class="help-module__link"
          :title="props.item.text"
          target="_blank"
          data-cy="help-module-link"
        >
          <span class="help-module__text" data-cy="help-module-text">{{
            props.item.text
          }}</span>
        </a>
      </template>
    </TileModule>
  </div>
</template>

<script setup lang="ts">
import { ref, watchEffect } from "vue";
import TileModule from "./TileModule.vue";
import { useMainStore } from "@/stores/useMainStore";
import { Pages } from "@/pages/pages";

const main = useMainStore();

interface LinkItem {
  text: string;
  url: string;
}

const items = ref<LinkItem[]>([]);

items.value = [
  {
    text: "Add/Update OUDirect Users",
    url: "/help/dashboard/logins.htm",
  },
  {
    text: "Add/Update Contacts",
    url: "/help/dashboard/contacts.htm",
  },
  {
    text: "Manage Ingredient Listing",
    url: "/help/dashboard/scheda.htm",
  },
  {
    text: "Manage Product Listing",
    url: "/help/dashboard/schedb.htm",
  },
  {
    text: "Kosher Dictionary",
    url: "/help/dashboard/kosher dictionary.htm",
  },
  {
    text: "Labeling Requirements",
    url: "/help/dashboard/labeling.htm",
  },
  {
    text: "FAQ",
    url: "/help/dashboard/faq.htm",
  },
  {
    text: "OUKosher.org",
    url: "https://oukosher.org/",
  },
];

const chometzSaleLinkSet = ref(false);
const setChometzSaleLink = function () {
  if (
    main.isChometzAvailable &&
    (main.companySummary?.JewishOwned ||
      main.companySummary?.HasJewishPlants) &&
    !chometzSaleLinkSet.value
  ) {
    items.value.push({
      text: "Chometz Sale",
      url: Pages.ChometzSales,
    });
    chometzSaleLinkSet.value = true;
  }
};

watchEffect(() => {
  setChometzSaleLink();
});
</script>

<style scoped lang="scss">
.help-module {
  &__title {
    background: #efefef;
    padding: 8px 15px;
    border: 1px solid #ddd;
    border-bottom: 0;
  }

  &__link {
    color: #399cd3;
    text-decoration: none;
    display: flex;
    justify-content: center;
    height: 100%;
  }

  &__icon {
    font-size: 16px;
  }
  :deep(.tile-module) {
    border: 1px solid #ddd;
    justify-content: flex-start;
    background: white;
    .tile-module__item {
      border: none;
    }
  }
}
</style>
